import { Flex } from '@assets/component/UI/Flex/Flex';
import { observer } from 'mobx-react';
import * as style from './DealScore.module.less';
import classNames from 'classnames';

interface IDealScoreProps {
    score: number | string;
    className?: string;
}

export const DealScore = observer((p: IDealScoreProps) => {
    var icon = 'bi bi-check';
    var text = 'Strong';
    var color = '#00A171';
    var showScore = true;

    var score: number = parseInt(p.score.toString());
    //temp hack
    //score = 90;
    //temp hack
    var scoreDisplay = score.toString();

    if (score > 85) {
        //defaults
    } else if (p.score == -1) {
        icon = 'bi bi-dash';
        text = 'No Data';
        color = '#6C757D';
        scoreDisplay = '--';
    } else if (score > 55) {
        //Medium
        icon = 'bi bi-dash';
        text = 'Med';
        color = '#FF9F00';
    } else {
        icon = 'bi bi-x';
        text = 'Weak';
        color = '#DD2222';
    }

    // Check if we should show dots instead of score
    const shouldShowDots = p.score == -1 || isNaN(score);
    const finalScoreDisplay = shouldShowDots ? '...' : scoreDisplay;

    var iconCls = classNames('bi', icon, style.icon);

    //scoreDisplay = 'TBD'
    return (
        <Flex
            className={style.scoreBox + ' ' + p.className}
            style={{ backgroundColor: color }}
            justify="between"
            alignItems="center"
        >
            <i className={iconCls}></i>
            <div className={style.text}>{text}</div>
            <div className={style.numberScore} style={{ color: color }}>
                {finalScoreDisplay}
            </div>
        </Flex>
    );

    //<div>{p.score}</div>;
});
